export default function HeroSection() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/45eb53bbcc38378d80dea03d4b5da687.jpg"
          alt="OSMICA iOS development background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-black/70 via-black/50 to-black/60" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-8 md:px-20 pt-24 pb-20">
        <div className="max-w-3xl">
          <span className="inline-block border border-white/40 text-white/80 text-xs uppercase tracking-widest px-4 py-2 rounded-full mb-8">
            iOS Development Experts
          </span>

          <h1 className="text-5xl md:text-7xl font-thin text-white leading-tight mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
            Modern Applications<br />
            <em className="not-italic font-light">for the iOS Platform</em>
          </h1>

          <p className="text-white/70 text-lg md:text-xl font-light leading-relaxed max-w-xl mb-12">
            We craft powerful, elegant iOS applications that enhance user experience
            and strengthen the security of mobile devices.
          </p>

          <button
            onClick={() => handleScroll('#about')}
            className="group flex items-center gap-3 text-white/80 hover:text-white transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            <span className="text-sm uppercase tracking-widest">Discover More</span>
            <span className="w-10 h-10 flex items-center justify-center border border-white/30 rounded-full group-hover:border-white/70 transition-colors duration-200">
              <i className="ri-arrow-down-line text-sm" />
            </span>
          </button>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 right-8 md:right-16 flex flex-col items-center gap-2 opacity-40">
        <div className="w-px h-16 bg-white animate-pulse" />
      </div>
    </section>
  );
}
